const hotelChains = {
  name: 'Chain |||| Chains',
  fields: {
    name: 'Name',
    hotelCount: 'Hotels',
    website: 'Website',
    country: 'Headquarters country',
    notes: 'Notes',
  },
  empty: 'No chains found',
  invite: 'Create your first chain',
};

export default hotelChains;
